export default {
    NAME: "Название атрибута",
    RU: "(ru)",
    EN: "(en)",
    NAME_PLACEHOLDER: "Введите название",
    TYPE: "Тип атрибута",
    TYPE_PLACEHOLDER: "Выберите тип атрибута",
    MAXIMUM_LENGTH_CHARS: "Макс. длина символов",
    DESCRIPTION: "Описание",
    DESCRIPTION_PLACEHOLDER: "Введите описание",
    MANDATORY: "Является обязательным",
    Label: "Является названием",
    REQUIRED_OPTION_EMPTY_MESSAGE: "Поле не заполнено"
};
